import Header from "./components/Header";
import Hero from "./components/Hero";
import Channels from "./components/Channels";
import Ranking from "./components/Ranking";
import Process from "./components/Process";
import Privacy from "./components/Privacy";
import Faq from "./components/Faq";
import CtaBand from "./components/CtaBand";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 font-sans text-foreground-900">
      <Header />
      <main>
        <Hero />
        <Channels />
        <Ranking />
        <Process />
        <Privacy />
        <Faq />
        <CtaBand />
      </main>
      <Footer />
    </div>
  );
}